// Thin wrapper over @mui/x-data-grid (v5) applying consistent, professional
// defaults. The visual styling (header, hover, borders, dark-mode colors)
// comes from the theme's MuiDataGrid overrides; this just standardizes props
// and wraps the grid in a themed Card so every table looks the same.

import React from "react";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";

// Borderless, square table surface — no card frame, matching the "no border
// across the dashboard" table direction. Just a themed paper background.
const ThemedDataGrid = ({ sx, height = 560, cardSx, ...props }) => (
  <Box
    sx={{
      bgcolor: "background.paper",
      borderRadius: 0,
      border: "none",
      p: 0,
      ...cardSx,
    }}
  >
    <DataGrid
      autoHeight={height == null}
      density="comfortable"
      disableSelectionOnClick
      rowsPerPageOptions={[10, 25, 50, 100]}
      pageSize={props.pageSize ?? 10}
      sx={{ height: height == null ? undefined : height, ...sx }}
      {...props}
    />
  </Box>
);

export default ThemedDataGrid;
